<template>
  <div class="app-root min-h-screen flex flex-col">
    <app-header />
    <main id="main-content" tabindex="-1" class="flex-1 w-full max-w-3xl mx-auto px-4 py-6 sm:py-10">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <keep-alive include="Home">
            <component :is="Component" />
          </keep-alive>
        </transition>
      </router-view>
    </main>
    <app-footer />
    <debug-panel />
  </div>
</template>

<script>
import AppHeader from '@/components/ui/AppHeader.vue'
import AppFooter from '@/components/ui/AppFooter.vue'
import DebugPanel from '@/components/ui/DebugPanel.vue'

export default {
  name: 'App',
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
    'debug-panel': DebugPanel
  }
}
</script>
